import clsx from 'clsx'

import styles from './Bubble.module.scss'

interface Props {
  color: string
  icon?: string
  text: string
  direction?: 'up' | 'down'
  className?: string
}

const Bubble = ({ color, icon, text, className, direction }: Props) => {
  function bubbleBorder() {
    if (direction === 'up') {
      return '0 26px 26px 26px'
    } else {
      return '26px 26px 26px 0'
    }
  }

  return (
    <div className={clsx(styles.container, className)} style={{ backgroundColor: color, borderRadius: bubbleBorder() }}>
      {icon && (
        <div className={styles.iconWrapper}>
          <img src={icon} alt="" />
        </div>
      )}
      <div className={styles.textWrapper}>
        <p>{text}</p>
      </div>
    </div>
  )
}

export default Bubble
